// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"904257d3","174":"17a2afe3","197":"8f14288e","202":"255c0d4a","219":"b2284df5","432":"bc537daa","463":"d3e612c4","533":"34794b6d","589":"2b5522e4","699":"e6d35de1","854":"237561fe","889":"02a9e920","936":"c86fdc50"}[chunkId] + ".chunk.js";
};